import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';

export type BackendReportExport =
  | 'general'
  | 'facilities'
  | 'players'
  | 'activities'
  | 'attendance'
  | 'revenues'
  | 'expenses'
  | 'balances';

@Injectable({ providedIn: 'root' })
export class ReportsExportManualService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  export(
    report: BackendReportExport,
    params: Record<string, unknown> = {},
  ): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.rootUrl}/api/v1/reports/${report}/export`, {
      params: this.buildParams(params),
      observe: 'response',
      responseType: 'blob',
    });
  }

  exportRevenueWorkbook(params: Record<string, unknown> = {}): Observable<HttpResponse<Blob>> {
    return this.export('revenues', { ...params, format: 'xlsx', tab: undefined });
  }

  private buildParams(params: Record<string, unknown>): HttpParams {
    let httpParams = new HttpParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        return;
      }

      if (Array.isArray(value)) {
        value.forEach((item) => {
          httpParams = httpParams.append(`${key}[]`, String(item));
        });
        return;
      }

      httpParams = httpParams.set(key, String(value));
    });

    return httpParams;
  }
}
